import React from 'react';
import { Calculator } from "lucide-react";
import { EvaluationPricingCard } from "@/components/pricing/EvaluationPricingCard";

export const NewPricingSection: React.FC = () => {
  return (
    <div id="pricing-section" className="py-24">
      <div className="container mx-auto px-6">
        {/* Consistent Header Pattern */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Evaluation-Based{" "}
            <span className="text-primary">Pricing</span>
          </h2>
          
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Scale your hiring with volume discounts. The more evaluations you need, the less you pay per evaluation.
          </p>
        </div>
        
        <EvaluationPricingCard />
      </div>
    </div>
  );
};
export default NewPricingSection;